import {action, observable, makeObservable} from 'mobx';
import {BaseTerms} from "../models/base-terms";
import {BaseUtils} from "./base-utils";
import {ARGS} from "../../core/bootstrap/args";

export class TermsUtils extends BaseUtils {
  @observable terms: Object;
  static injectables = [];

  constructor() {
    super();

    this.terms = {};

    makeObservable(this);
  }

  @action populateTerms(dataSource) {
    for (const key in Object.fromEntries(dataSource.terms)) {
      this.terms[key] = this.isAliasNameView ? key : (dataSource.terms.get(key));
    }
  }

  get isAliasNameView(): Boolean {
    const isAliasNameView = ARGS.EXPOSE_ALIAS_NAMES === "true";

    return isAliasNameView;
  }

  @action populateI18n(i18n: BaseTerms) {
    if (!i18n) {
      return this.terms;
    }

    for (const key in i18n) {
      this.terms[key] = this.isAliasNameView ? key : (this.terms[key] || i18n[key]);
    }

    return this.terms;
  }

  formatTerm(term, params) {
    return term?.format(params);
  }
}

